import { createSlice } from '@reduxjs/toolkit';
import { AESEncryption } from '../../utils/Aes';

const initialState = {
  isLoggedIn: false,
  token: null,
  userCompany: null,
  role: null,
  companyId:null,
  userId: null,
  loading: false,
  error: null,
  userDetailsId:null
};

export const authSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {      
      state.isLoggedIn = true;
      state.token = action.payload.token;
      state.userCompany = action.payload.userCompany;
      state.userId = action.payload.userCompany.id;
      state.companyId = action.payload.companyId;
      state.role = action.payload.role;
      state.loading = false;      
      state.userDetailsId = action.payload.userDetailsId;      
    },
    loginCompany: (state, action) => {
      const encryptedCompanyId = AESEncryption((action.payload.companyId).toString())
      localStorage.setItem('companyId', encryptedCompanyId);
      state.companyId = action.payload.companyId;
      state.role = action.payload.role;
      state.userDetailsId = action.payload.userDetailsId ?? state.userDetailsId;

    },
    loginFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.token = null;
      state.userCompany = null;
      state.userId = null;
      state.companyId = null;
      state.userDetailsId = null;
      localStorage.removeItem('token');
      localStorage.removeItem('companyId');

      
      try {
        const { disconnectNotificationSocket } = require('../../notificationSocketService');
        disconnectNotificationSocket();
      } catch (_) { /* ignore if not available */ }
      try {
        const socketService = require('../../service/SocketService').default;
        socketService.disconnect();
      } catch (_) { /* ignore if not available */ }
    },
  },
});

export const { loginStart, loginSuccess,loginCompany, loginFailure, logout } = authSlice.actions;

export default authSlice.reducer;
